import BaseEntity  from '@/core/misc/BaseEntity';
import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Торговая марка')
class TradeMark extends BaseEntity {

  /** удаления нет, создание происходит неявно */

  static Events = {
    Updated: 'tradeMark:updated',
  } as const;

  @Title_ru_RU('Название', TYPES.STRING)
  public name: string;

  static fromServer(data: any, result = new TradeMark()): TradeMark {
    super.fromServer(data, result);

    return result;
  }

  toString(): string {
    return this.name;
  }
}

export default TradeMark;
